module.exports = __webpack_public_path__ + "media/images/coins-91363d742642d78f1a440c13e95bccd5.png";